import styled from "styled-components";

const CardColored = styled.div`
  color: white;
  margin: 0 10px;
  border-radius: 18px;
  /* width: 270px; */
  padding: 20px;
  /* border-radius: 12px; */
  flex-basis: 30%;
  display: flex;
  /* align-items: center; */
  justify-content: space-evenly;
  flex-direction: column;
  /* height: 100%; */
  background-color: ${({ status }) => {
    switch (status) {
      case 0:
        return "#5d9cec";

      case 1:
        return "#4fc1e9";

      case 2:
        return "#4fc1e9";

      case 3:
        return "#4fc1e9";

      case 4:
        return "#48cfad";

      case 5:
        return "#f6a742";
      case 10:
        return "#ed5565";

      default:
        return "gray";
    }
  }};

  .vehicle {
    border-radius: 8px;
    width: 246px;
    height: 30px;
    background-color: #f4f4f5;
    color: black;
    margin: auto;
  }

  .vehicle > span {
    vertical-align: sub;
  }
`;

const Container = styled.div`
  padding: 10px;
  margin-bottom: 80px;
  border-radius: 18px;
  box-shadow: 0 5px 20px 0 rgba(42, 46, 67, 0.25);
  background-color: #f5f5f5;
  overflow: hidden;
  .border-bottom > div {
    flex-basis: 35%;
    justify-content: space-between;
  }

  .desc {
    background-color: #f5f5f6;
    border-radius: 15px;
    flex-basis: 25%;
  }
  .left-badge {
    color: white;
    font-weight: bold;
    text-align: center;
    padding: 8px;
    font-size: 0.95em;
    height: max-content;
    align-self: center;
    border-radius: 5px;
    writing-mode: vertical-lr;
    -webkit-writing-mode: vertical-lr;
    transform: rotate(180deg);
    background-color: #ffbf1d;

    position: absolute;
    left: 0;
    top: 0;
    height: calc(100% - 32px);
  }
`;
export const BitsContainerStyled = styled.div`
  flex-wrap: wrap;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* padding: 6px; */
  /* margin:0 20px; */
`;
export const PriceStyled = styled.div`
  margin: 6px 0;
  padding: 3px 6px;
  opacity: 0.05;
  border-radius: 8px;
  background-color: #2a2e43;
`;
export const BitsSingleStyled = styled.div`
  padding: 6px;
  /* width: 95%; */
  border-radius: 12px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.05);
  background-color: #fff !important;
  margin: 10px !important;

  & > .bit__price {
    background-color: #f4f4f5;
    /* font-size: 1.2em; */
    font-weight: bold;
    text-align: center;
    padding: 5px;
    border-radius: 8px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: baseline;
  margin-right: 10px;
`;
export const UserProfileImage = styled.img`
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 5px;
  /* opacity: 0.8; */
`;

export { CardColored, Container };
